// TODO: move file outside of request container
import * as React from "react"
import { Typography } from "antd"
import PropTypes from "prop-types"
import "./Panel.scss"

const { Text } = Typography

const Panel = ({ title, subtitle, actions, children, iconClassName, className, style = {} }) => {
  return (
    <div
      className={`panel${className ? " " + className : ""}`}
      style={style}
    >
      {actions && <div className="panel-actions">{actions}</div>}
      <div className="panel-header">
        {iconClassName && <i className={iconClassName} />}
        <div className="panel-title">{title}</div>
      </div>

      <div className="panel-content">
        <div className="subtitle-container">{subtitle && <Text className="panel-subtitle">{subtitle}</Text>}</div>
        {children}
      </div>
    </div>
  )
}

Panel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Buttons to open modals, grid filters , tooltip etc, is usually sent for the **actions** prop. */
  actions: PropTypes.node,
  /** **Children** prop will populate the panel's main content area. */
  children: PropTypes.node,
  /** **iconClassName** prop will add an icon to the panel title. Change the name from control to change the icon. */
  iconClassName: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Panel
